import { createContext, useContext } from "react";
import type { PaymentCancellationReminderRequest } from "./PaymentCancellationReminders";

type BookingContext = {
  showReminders: (request: PaymentCancellationReminderRequest, onCreated: () => void) => void;
};
export const BankStatementBookingContext = createContext<BookingContext | null>(null);

export function useBankStatementBooking() {
  const context = useContext(BankStatementBookingContext);
  if (!context) throw new Error("BankStatementBookingProvider is required");
  return context;
}
